import { render, staticRenderFns } from "./ExamManage.vue?vue&type=template&id=072fd750&scoped=true&"
import script from "./ExamManage.vue?vue&type=script&lang=js&"
export * from "./ExamManage.vue?vue&type=script&lang=js&"
import style0 from "./ExamManage.vue?vue&type=style&index=0&id=072fd750&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072fd750",
  null
  
)

export default component.exports